const ApiKeys = () => import("Core/configuration/api_keys/views/ApiKeys");
const ApiKeysForm = () => import("Core/configuration/api_keys/views/ApiKeysForm");

export default {
    children: [
        {
            path: "configuration/api_keys",
            name: "api_keys",
            component: ApiKeys,
            meta: {
                requiresAuth: true,
                title: "lang.api_keys",
                restrict_by_login_type: ["customer_support", "administrator", "employee", "developer"],
                restrict_by_permission: ["api_keys.read"],
            },
        },
        {
            path: "configuration/api_key/:id?",
            name: "api_key",
            component: ApiKeysForm,
            meta: {
                requiresAuth: true,
                title: "lang.api_keys",
                restrict_by_login_type: ["customer_support", "administrator", "employee", "developer"],
                restrict_by_permission: ["api_keys.read"],
            },
        },
    ],
};
